<template>
  <div>
    <header-part />
    <search />
    <div class="content card">
      <category></category>
      <rotation :parent="rotation"/>
      <serve :parent="service"/>
      <sec-kill v-if="secKill!==null && secKill.length"  :parent="secKill"/>
      <hot-goods v-if="hotGoods!==null && hotGoods.length"  :parent="hotGoods"/>
      <recommend v-if="goodsByHome.goodsList && goodsByHome.goodsList.length" :parent="goodsByHome"/><!--家用探测-->
      <industrial-goods v-if="goodsByIndustrial.goodsList && goodsByIndustrial.goodsList.length"  :parent="goodsByIndustrial"/><!--工业探测器-->
      <gas-goods v-if="GasGoods.goodsList && GasGoods.goodsList.length"  :parent="GasGoods"/><!--气体系统-->
      <fire-control-power-supply-goods v-if="FireControlPowerSupplyGoods.goodsList && FireControlPowerSupplyGoods.goodsList.length"  :parent="FireControlPowerSupplyGoods"/><!--消防电源-->
      <firedoor-goods v-if="FiredoorGoods.goodsList && FiredoorGoods.goodsList.length"  :parent="FiredoorGoods"/><!--防火门-->
      <electrical-fire-goods v-if="ElectricalFireGoods.goodsList && ElectricalFireGoods.goodsList.length"  :parent="ElectricalFireGoods"/><!--电气火灾-->
      <valves-goods v-if="ValvesGoods.goodsList && ValvesGoods.goodsList.length" :parent="ValvesGoods"/><!--阀门产品-->
    </div>
    <my-footer />
  </div>
</template>





 <!-- //新品首发（子）
      secKill: [],
      //人气商品（子）
      hotGoods: [],
      //家用探测器
      goodsByHome: [],
      //工业探测器
      goodsByIndustrial: [],
      //气体系统
      GasGoods: [],
      //消防电源
      FireControlPowerSupplyGoods: [],
      //防火门
      FiredoorGoods: [],
      //电气火灾
      ElectricalFireGoods: [],
      //阀门产品
      ValvesGoods: [],-->

<script>
import HeaderPart from '@/views/PC/header/HeaderPart';
import Search from '@/views/PC/search/Search';//搜索部分
import Category from '@/views/PC/category/Category';//商品分类
import Rotation from '@/views/PC/rotation/Rotation';//大图轮播
import Serve from '@/views/PC/serve/Serve';//用户信息与公告部分
import SecKill from '@/views/PC/secKill/SecKill.vue';//新品首发
import HotGoods from '@/views/PC/hotgoods/HotGoods.vue';//热门商品
import Recommend from '@/views/PC/recommend/Recommend.vue';//家用探测器
import IndustrialGoods from '@/views/PC/industrial/IndustrialGoods.vue';//工业探测器
import GasGoods from '@/views/PC/gas/GasGoods.vue';//气体系统
import FireControlPowerSupplyGoods from '@/views/PC/FireControlPowerSupply/FireControlPowerSupplyGoods.vue';//消防电源
import FiredoorGoods from '@/views/PC/firedoor/FiredoorGoods.vue';//防火门
import ElectricalFireGoods from '@/views/PC/electricalFire/ElectricalFireGoods.vue';//电气火灾
import ValvesGoods from '@/views/PC/valves/ValvesGoods.vue';//阀门产品
import MyFooter from '@/views/PC/footer/MyFooter.vue';
import { getIndex } from '@/api/home/home'
export default {
  name: 'Index',
  components: {
    HeaderPart,
    Search,
    Category,
    Rotation,
    Serve,
    SecKill,
    HotGoods,
    Recommend,
    IndustrialGoods,
    GasGoods,
    FireControlPowerSupplyGoods,
    FiredoorGoods,
    ElectricalFireGoods,
    ValvesGoods,
    MyFooter,
  },
  data() {
    return {
      //所有数据（父）
      indexList: [],
      //轮播数据（子）
      rotation: [],
      //信息公告（子）
      service: [],
      //新品首发（子）
      secKill: [],
      //人气商品（子）
      hotGoods: [],
      //家用探测器
      goodsByHome: [],
      //工业探测器
      goodsByIndustrial: [],
      //气体系统
      GasGoods: [],
      //消防电源
      FireControlPowerSupplyGoods: [],
      //防火门
      FiredoorGoods: [],
      //电气火灾
      ElectricalFireGoods: [],
      //阀门产品
      ValvesGoods: [],

    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      if(this.$store.state.userInfo == undefined || this.$store.state.userInfo.type == undefined){
        this.$router.push( { path: '/PC/Login' } )
      }
      // else if(this.$store.state.userInfo.type == 1){
      //   this.$router.push( { path: '/PC/mine' } )
      // }
      
      getIndex().then(response => {
        if(!!!response){
          return;
        }
        this.indexList = response.data;
        //轮播子件数据
        this.rotation = response.data.banner;
        //信息公告子件数据
        this.service = response.data.articles;
        //新品首发子件数据
        this.secKill = response.data.newGoodsList;
        //人气商品子件数据
        this.hotGoods = response.data.hotGoodsList
        //适用位置探测器
        for (var i=0; i < response.data.floorGoodsList.length; i++) {//先根据name判断 后期有变化更改下方name
          if (response.data.floorGoodsList[i].id == 18) {//家用探测器
            this.goodsByHome = response.data.floorGoodsList[i]
          }else if (response.data.floorGoodsList[i].id == 22) { //工业探测器
            this.goodsByIndustrial = response.data.floorGoodsList[i]
          }else if (response.data.floorGoodsList[i].id == 41) {//气体系统
            this.GasGoods = response.data.floorGoodsList[i]
          }else if (response.data.floorGoodsList[i].id == 42) {//消防电源
            this.FireControlPowerSupplyGoods = response.data.floorGoodsList[i]
          }else if (response.data.floorGoodsList[i].id == 43) {//防火门
            this.FiredoorGoods = response.data.floorGoodsList[i]
          }else if (response.data.floorGoodsList[i].id == 50) {//电气火灾
            this.ElectricalFireGoods = response.data.floorGoodsList[i]
          }else if (response.data.floorGoodsList[i].id == 60) {//阀门产品
            this.ValvesGoods = response.data.floorGoodsList[i]
          }
        }

      })
    }
  }
};
</script>

<style scoped>
.content {
  width: 1200px;
  margin: 10px auto;
}
</style>



// WEBPACK FOOTER //
// src/views/PC/Pages/Index.vue